"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'PortConfigurationPH',
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    roleCode: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayInit: {
      type: [String, Array],
      default: null
    },
    placeholder: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      internalValue: this.value,
      columns: [{
        title: this.$t('home.country'),
        field: 'countryCode',
        width: '200px'
      }, {
        title: this.$t('home.portCodeOne'),
        field: 'portCode',
        width: '200px'
      }, {
        title: this.$t('home.portName'),
        field: 'portName',
        width: '200px'
      }, {
        title: this.$t('home.portCodeTwo'),
        field: 'portNameCn',
        width: '200px'
      }]
    };
  },
  created: function created() {
    this.internalValue = this.value;
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    isPHPortsOnly: function isPHPortsOnly() {
      if (!this.value || !Array.isArray(this.value) || this.value.length === 0) {
        return true;
      }
      return this.value.every(function (port) {
        return port && port.startsWith('PH');
      });
    },
    dynamicMultiple: function dynamicMultiple() {
      return true;
    }
  }),
  methods: {
    queryMethod: function queryMethod(_ref) {
      var keyword = _ref.keyword,
        pageSize = _ref.pageSize,
        currentPage = _ref.currentPage;
      console.log('keyword', keyword, this.displayInit);
      var data = {};
      data.roleCode = this.roleCode;
      data.currentPage = currentPage;
      data.pageSize = pageSize;
      if (keyword !== '') {
        data.portCode = keyword;
        data.portNameCn = keyword;
        data.portName = keyword;
      }
      if (data.portCode) {
        data.portCode = '%' + data.portCode + '%';
      }
      if (data.portNameCn) {
        data.portNameCn = '%' + data.portNameCn + '%';
      }
      if (data.portName) {
        data.portName = '%' + data.portName + '%';
      }
      return new Promise(function (resolve, reject) {
        (0, _booking.queryListPortConfiguration)(data).then(function (res) {
          resolve({
            records: res.data.records,
            total: res.data.totalRecord,
            recordStart: res.data.recordStart,
            recordEnd: res.data.recordEnd
          });
        });
      });
    },
    change: function change(val, selectedRows) {
      var finalVal = val;
      if (Array.isArray(val) && val.length > 0) {
        // 获取最新选择的港口
        var lastSelectedPort = val[val.length - 1];

        // 获取最新选择港口的国家代码（前两位字符）
        var lastCountryCode = lastSelectedPort.substring(0, 2);

        // 过滤出与最新选择港口相同国家的所有港口
        var sameCountryPorts = val.filter(function (port) {
          return port && port.substring(0, 2) === lastCountryCode;
        });
        if (lastCountryCode === 'CN') {
          // CN开头的港口只能选择一个，保留最新选择的
          finalVal = [lastSelectedPort];
        } else {
          // 其他国家的港口可以选择多个，只保留相同国家的港口
          finalVal = sameCountryPorts;
        }
      }
      this.internalValue = finalVal;
      this.$emit('input', finalVal);
      this.$emit('change', finalVal, selectedRows, this.index);
    },
    focus: function focus() {
      this.$emit('focus');
    },
    blur: function blur() {
      this.$emit('blur');
    },
    visibleChange: function visibleChange(visible) {
      this.$emit('visible-change', visible);
    }
  }
};